import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { IconButton } from '@awaze/design-system.components.button';
import { Input } from '@awaze/design-system.components.input';
import { Minus, Plus } from './icon';
import { StepperStyled, StyledButtonContainer } from './stepper.styles';
/**
 * A (+ / - ) input component.
 */
export const Stepper = ({ initialValue = 0, minimum = 0, maximum = 100, step = 1, name, callBack, colourScheme = 'brand-tertiary', rounded = true, formHooks, translations, className, disableStepperInput, ...rest }) => {
    const [inputValue, setInputValue] = useState(initialValue);
    if (minimum && minimum > initialValue) {
        useEffect(() => {
            setInputValue(minimum);
        }, [minimum]);
    }
    useEffect(() => {
        const initialValue = formHooks && formHooks.getValues(name);
        formHooks && typeof initialValue === 'number' && valueHandler(initialValue);
    }, []);
    useEffect(() => {
        formHooks && formHooks.setValue(name, inputValue);
        callBack && callBack(inputValue);
    }, [inputValue]);
    function valueHandler(val) {
        if (val >= minimum && val <= maximum) {
            setInputValue(val);
        }
        else if (val < minimum) {
            setInputValue(minimum);
        }
        else if (val > maximum) {
            setInputValue(maximum);
        }
        else {
            throw new Error('Value is not a number!');
        }
    }
    function changeHandler(e) {
        const val = Math.round(+e.target.value);
        valueHandler(val);
        callBack && callBack(inputValue);
    }
    const decrementHandler = () => {
        setInputValue((prevState) => prevState - step >= minimum ? prevState - step : prevState);
    };
    const incrementHandler = () => {
        setInputValue((prevState) => {
            const nextStep = prevState + step;
            const newValue = nextStep <= maximum ? nextStep : prevState;
            return newValue;
        });
    };
    const { decreaseAriaLabel, increaseAriaLabel, ariaLabelName, fullDecreaseAriaLabel, fullIncreaseAriaLabel, } = translations;
    return (_jsxs(StepperStyled, { className: className, children: [_jsx(StyledButtonContainer, { colourScheme: colourScheme, isDisabled: inputValue <= minimum, children: _jsx(IconButton, { colourScheme: colourScheme, icon: _jsx(Minus, {}), isDisabled: inputValue <= minimum, onClick: () => decrementHandler(), title: fullDecreaseAriaLabel ?? `${decreaseAriaLabel} ${ariaLabelName}`, variant: "outline", "aria-label": fullDecreaseAriaLabel ?? `${decreaseAriaLabel} ${ariaLabelName}`, rounded: rounded, type: "button", "data-testid": `${name}-remove` }) }), _jsx(Input, { name: name, type: "number", "data-testid": "stepper-number-input", value: inputValue.toString(), onChange: (event) => changeHandler(event), min: minimum.toString(), max: maximum.toString(), step: step.toString(), isDisabled: disableStepperInput, ...rest }), _jsx(StyledButtonContainer, { colourScheme: colourScheme, isDisabled: inputValue >= maximum, children: _jsx(IconButton, { colourScheme: colourScheme, icon: _jsx(Plus, {}), isDisabled: inputValue >= maximum, onClick: () => incrementHandler(), title: fullIncreaseAriaLabel || `${increaseAriaLabel} ${ariaLabelName}`, variant: "outline", "aria-label": fullIncreaseAriaLabel || `${increaseAriaLabel} ${ariaLabelName}`, rounded: rounded, type: "button", "data-testid": `${name}-add` }) })] }));
};
//# sourceMappingURL=stepper.js.map